import { InsulationElement } from "./InsulationElement";
import { InsulationElementType } from "../../constants/combo/InsulationElementType";
export class BasementFloorElement extends InsulationElement {
  getElementType = () => InsulationElementType.BASEMENT_FLOOR;
  getMaxWidth = () => 50.0;
}
